<div class="interval-10">
    <ng-container *ngIf="isEdit">
        <span *ngIf="status === CA_STATUS.VALID && !isReupload" [class.mr-8]="SWITCH.IS_SIMPLE_MODE">{{statusText[status]}}</span>
        <p-fileUpload *ngIf="status !== CA_STATUS.VALID || isReupload"
            #uploadEl
            class="ca-upload-control"
            [class.has-error]="errorMsg"
            name="file[]"
            [url]="uploadUrl"
            [showUploadStatus]="false"
            [allowRepeatFiles]="true"
            accept=".crt,.pem"
            allowFileSuffix=".crt,.pem"
            maxFileSize="2097152"
            [uploadButtonVisible]="false"
            (onSelect)="onSelectPatch($event, uploadEl, onSelect)"
            (onBeforeSend)="onBeforeSend($event)"
            (onUpload)="onUpload($event)"
            (onError)="onError()">
        </p-fileUpload>
        <button *ngIf="status === CA_STATUS.VALID && !isReupload"
            nButton
            [label]="i18n.reupload"
            (click)="onReupload()">
        </button>
        <button *ngIf="status === CA_STATUS.VALID && isReupload"
            nButton
            [label]="i18n.cancelReupload"
            (click)="onCancelReupload()">
        </button>
    </ng-container>
    <span *ngIf="!isEdit">{{hasReadPermission ? statusText[status || CA_STATUS.NOT_EXIST] : UNPLACEHOLDER}}</span>
</div>
<n-tip *ngIf="errorMsg"
    type="failed"
    [content]="errorMsg">
</n-tip>
